import EmptyStateButton from "../EmptyStateButton";
import { Colors } from "../../../utils/colors";
import { Icon } from "@iconify/react";
import { SubscriptionPlanType } from "@markit/common.types";
import { notificationActions } from "../../../redux/slices/notificationSlice";
import { useDispatch } from "react-redux";
import { CSSProperties, ReactNode } from "react";

type EmptyStateButtonSubscriptionProps = {
  planType: SubscriptionPlanType;
  iconName: string;
  btnText: string;
  btnIconRight?: ReactNode;
  description?: string;
  containerStyles?: CSSProperties;
};

// Builds off of EmptyStateButton for a standardized subscription upgrade button.
const EmptyStateButtonSubscription = (
  props: EmptyStateButtonSubscriptionProps
) => {
  const {
    planType,
    iconName,
    btnText,
    btnIconRight,
    description,
    containerStyles,
  } = props;
  const dispatch = useDispatch();

  return (
    <EmptyStateButton
      title={
        <span>
          Available with Markit
          <span style={{ color: Colors.BLUE5 }}>+ </span>
          {planType.name} Plan
        </span>
      }
      description={description}
      icon={
        <Icon icon={iconName} height={50} style={{ color: Colors.BLACK }} />
      }
      iconBox={70}
      iconBackgroundColor={Colors.WHITE1}
      btnText={btnText}
      btnIconRight={btnIconRight}
      onPress={() =>
        dispatch(notificationActions.setMarkitPlusModal(planType.name))
      }
      containerStyles={{ paddingTop: 120, ...containerStyles }}
    />
  );
};

export default EmptyStateButtonSubscription;
